export default "__VITE_ASSET__zgXOoyJy__"